import React from 'react';

function GhostText({ allQuestions }) {
  return (
    <div className="ghostContent">
      {Array.from(allQuestions).map((item, index) => {
        return <span key={index}>{item.title + item.comment + item.choices[0] + item.choices[1] + item.choices[2] + item.choices[3]}</span>;
      })}
      <span>{'0' + '1' + '2' + '3' + '4' + '5' + '6' + '7' + '8' + '9' + 'もういちどチャレンジして満点をめざそう！'}</span>
    </div>
  );
}

export default GhostText;
